import { useFormatter } from 'next-intl';
import React from 'react';
import { Numeric } from '@/lib/types/common';
import { Text, TextProps } from '@/lib/ui-kit/text';
import { formatMoney, isBelowMoneyThreshold } from '@/lib/utils/formatAmount';

type USDTextProps<C extends React.ElementType = 'span'> = TextProps<C> & {
  value: Numeric; // value from 0 to 1
  alwaysShowDecimals?: boolean; // If true, always show 2 decimal places
};

export function USDText<C extends React.ElementType = 'span'>({
  value,
  alwaysShowDecimals = false,
  ...allTextProps
}: USDTextProps<C>) {
  const format = useFormatter();
  const numeric = Number(value);
  // Money reads at 3 (and falls back to "> $0.001"); volume-style
  // readouts keep their whole-number look.
  const text =
    alwaysShowDecimals || isBelowMoneyThreshold(numeric)
      ? formatMoney(numeric, { prefix: '$' })
      : `${numeric < 0 ? '-' : ''}$${format.number(Math.abs(numeric), {
          maximumFractionDigits: 3,
          trailingZeroDisplay: 'stripIfInteger',
        })}`;
  return <Text<C> {...(allTextProps as TextProps<C>)}>{text}</Text>;
}
